import z from 'zod';
import { CountSheetSummarySchema } from './CountSheetSummary';

export const CountSheetStatusesResultSchema = z.object({
    data: z.array(CountSheetSummarySchema),
    total: z.number(),
});

export type CountSheetStatusesResult = z.infer<typeof CountSheetStatusesResultSchema>;
